import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialModal } from 'components/layout'
import { Textarea } from 'components/fields'
import { form } from 'helpers/decorators'
import { apiDashboard } from 'helpers/decorators/api'
import validate from './assessor-reject-validation'

@apiDashboard.apiPersons()
@form({
  form: 'form-stop-assessing-section',
  disableHook: true,
  validate
})
class AssessorReject extends Component {
  static propTypes = {
    onConfirm: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    colorClass: PropTypes.string,
    valid: PropTypes.bool,
    submitting: PropTypes.bool
  }

  render() {
    const { handleSubmit, colorClass, valid, submitting } = this.props

    return (
      <form onSubmit={handleSubmit(this.props.onConfirm)}>
        <div className="row">
          <div className="col-xs-12">
            <Textarea name="reason" label="Reason" intlKey="label.reason" />
          </div>
        </div>
        <MaterialModal.Footer
          colorClass={colorClass}
          action="Confirm"
          actionKey="button.confirm"
          insideContent
          disabled={!valid}
          isLoading={submitting}
        />
      </form>
    )
  }
}

export default AssessorReject
